import { useController as o } from "react-hook-form";
function t(r) {
  return o(r);
}
export {
  t as u
};
//# sourceMappingURL=use-rhf-wrapper-controller-DGFm3TD5.mjs.map
